import React from "react";
import { useSelector } from "react-redux";
import Pagination from "../Pagination/Pagination";
import Table from "../Table/Table";

const OBJ_TABLE = {
  "Stripe Transaction Id": "stripeTransactionId",
  "Total Accounts": "totalUsers",
  "Payable Accounts": "payableUsers",
  Amount: "amount",
  Status: "status",
  "Created At": "createdAt",
};

const ViewPaymentHistory = ({ transactions }) => {
  const page = 1;
  const perPage = 0;
  const totalDocuments = 10;
  const currentSort = {
    sortBy: "Created At",
    order: "desc",
  };
  const { records_per_page } = useSelector((state) => state.setting);

  if (transactions?.length > 0) {
    return (
      <div className="dataTables_wrapper ">
        <Table
          currentSort={currentSort}
          mainData={transactions}
          tableHeading={Object.keys(OBJ_TABLE)}
          tableData={Object.values(OBJ_TABLE)}
          onlyDate={{
            createdAt: "dateTime",
            startDate: "dateTime",
            endDate: "dateTime",
            addedAt: "dateTime",
          }}
          dontShowSort={["status", "cancelled"]}
          renderAs={{
            status: (data, id) =>
              data === "PAID" ? (
                <span className="label label-lg label-light-success label-inline">
                  PAID
                </span>
              ) : (
                <span className="label label-lg label-light-danger label-inline">
                  FAILED
                </span>
              ),
          }}
        />

        {perPage !== 0 && (
          <Pagination
            page={page}
            totalDocuments={totalDocuments}
            perPage={perPage}
            defaultPerPage={records_per_page}
          />
        )}
      </div>
    );
  }

  return "No Transactions Found";
};

export default ViewPaymentHistory;
